import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * The one notification box for results, warnings and hints: teal, with normal body text, readable in both themes.
 * Do not hand-colour notices with amber/green/red light palettes (bg-amber-50 and the like): they ignore the theme
 * and come out as a pale box with faint text on the dark theme. Use this instead.
 */
export function NoticeBox({ children, className, testId, role = "note" }: { children: ReactNode; className?: string; testId?: string; role?: "note" | "status" | "alert" }) {
  return (
    <div role={role} data-testid={testId} className={cn("rounded-lg border border-primary/40 bg-primary/10 p-3 text-foreground", className)}>
      {children}
    </div>
  );
}
